import { useState } from "react";
import CATEGORIES from "../data/categories";
import { useApp } from "../context/AppContext";

function getCategoryLabel(catId) {
  const found = CATEGORIES.find((c) => c.id === catId);
  return found ? found.label : catId;
}

export default function ProductCard({ product }) {
  const { navigate } = useApp();
  const [saved, setSaved] = useState(false);

  const isOrderable = product.cat === "other";

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  return (
    <div className="product-card">
      <div className="product-card-img">
        <span>{product.emoji}</span>
        {product.badge && (
          <span className={`product-badge ${product.badgeColor}`}>{product.badge}</span>
        )}
        {isOrderable && <span className="product-orderable-tag">Order Online</span>}
      </div>

      <div className="product-card-body">
        <div className="product-cat-tag">{getCategoryLabel(product.cat)}</div>
        <div className="product-name">{product.name}</div>
        <div className="product-desc">{product.desc}</div>

        <div className="product-footer">
          <div>
            <div className="product-price">{product.price}</div>
            <div className="product-price-note">{isOrderable ? "Per unit" : "In-store price"}</div>
          </div>

          {isOrderable ? (
            <button
              className="product-view-btn"
              onClick={() => navigate("product-detail", "other", product)}
            >
              View &amp; Order
            </button>
          ) : (
            <button
              className={`product-add-btn ${saved ? "added" : ""}`}
              onClick={handleSave}
              title="Save item"
            >
              {saved ? "✓" : "+"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
